import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Cards, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { Icon } from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { iconMap, ItemCheck } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, } from '../../../../commons/functions';
import { useStore } from '../../../store';



export const MembersEDVFaiPage = () => {
    //const storeAdmin = useStoreAdmin();



    const [editIntructor, setEditIntructor] = useState(false);
    const [helpOpen, setHelpOpen] = useState(false);
    const [isCancel, setIsCancel] = useState(false);
    const [showVoid, setShowVoid] = useState(false);
    const [cancelReason, setCancelReason] = useState("");
    const [sideOpen, setSideOpen] = useState(false);
    const [userPickerModal, setUserPickerModal] = useState(false);
    const [activeTab, setActiveTab] = useState("search");

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    const [check, setCheck] = useState<ItemCheck>();
    const [mychecks, setMychecks] = useState<ItemCheck[]>([]);


    const { idUser, menu, parameters } = useGlobalState();



    const handleCheckMine = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/checks/requests/search',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    equipmentCheck: "FAI",
                    idUser: idUser,
                    pending: false,
                    orderBy: "dateSubmited",
                    order: "desc",
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setMychecks(data.checks);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    const handleCheckEval = (idCheckParameter: string, opt: any) => {
        if (check && check.statusRequest == 1 && check.idInstructor == idUser && activeTab === "mychecks") {
            setCheck((prev: any) => ({
                ...prev,
                jsonResults: prev.jsonResults.map((item: any) =>
                    item.idCheckParameter === idCheckParameter
                        ? { ...item, resultValue: opt.value, resultText: opt.text }
                        : item
                ),
            }));
        }
    };


    useEffect(() => {
        handleCheckMine()
    }, []);



    type Tab = {
        label: string;
        id: string;
        content: React.ReactNode;
    };
    return (
        <CustomAppLayout
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />}
                        //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Mis pruebas deportivas
                        </Header>



                        <Cards
                            items={mychecks.map((check: ItemCheck) => ({
                                name: `Prueba FAI - ${check.check || ''}`,
                                dateResult: check.dateResult,
                                icon: check.icon,
                                description: `Usuario: ${check.requisitosCondicion}`,
                            }))}
                            cardDefinition={{
                                header: item => (
                                    <Header variant='h2'
                                    >
                                        <Icon path={iconMap[item.icon || ""] || "" as string} size={1.5} /> {item.name}
                                    </Header>
                                ),
                                sections: [
                                    {
                                        id: "type",
                                        header: "Obtención",
                                        content: item => item.dateResult
                                    },
                                ]
                            }}
                            cardsPerRow={[
                                { cards: 1 },
                                { minWidth: 500, cards: 2 }
                            ]}

                            loadingText="Loading resources"
                            selectionType={undefined}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin medallas</b>
                                    </SpaceBetween>
                                </Box>
                            }


                        />
                    </SpaceBetween>



                </>
            }
        />
    );
};

function getColor(hex: string): "green" | "blue" | "red" | "grey" | "severity-low" {
    switch (hex.toLowerCase()) {
        case "#00b000":
            return "green";
        case "#007cff":
            return "blue";
        case "#ff0000":
            return "red";
        case "#999999":
            return "severity-low";
        default:
            return "grey";
    }
}